<script lang="ts">
    import VanVolxemLogo from '$lib/assets/vectors/VanVolxemLogo.svelte';
    import { useLocaleContext } from '$lib/context';

    const lang = useLocaleContext();

    let innerWidth: number;
</script>

<svelte:window bind:innerWidth />

<nav class="navbar absolute w-full bg-black !px-5 z-[52]">
    <a href="/{lang}/" class="w-fit mx-auto pb-1.5 2xl:pb-1">
        <VanVolxemLogo />
    </a>
</nav>
